export type EarnPageCampaignLike = {
  is_joined?: boolean | null;
  youtube_channels?: ({ is_autoclipper_partner?: boolean | null } | null)[] | null;
};

export type EarnPageCampaignSplit<T> = {
  /** Campaigns the viewer already joined — their own stake, listed first. */
  joined: T[];
  /** Open campaigns they have not joined. */
  internal: T[];
  /** Autoclipper-partner campaigns they have not joined. */
  partner: T[];
};

/**
 * `/earn` lists campaigns three times over — the viewer's own, the open ones
 * and the partner ones. Splitting in one place is what guarantees a joined
 * partner campaign is lifted into "my campaigns" instead of rendering a second
 * card further down the page.
 */
export function splitEarnPageCampaigns<T extends EarnPageCampaignLike>(
  campaigns: T[],
): EarnPageCampaignSplit<T> {
  const split: EarnPageCampaignSplit<T> = { joined: [], internal: [], partner: [] };

  for (const campaign of campaigns) {
    if (campaign.is_joined) {
      split.joined.push(campaign);
      continue;
    }
    const isPartner = (campaign.youtube_channels ?? [])
      .some((channel) => !!channel?.is_autoclipper_partner);
    (isPartner ? split.partner : split.internal).push(campaign);
  }

  return split;
}
